import React from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function NewCTABanner() {
  const {
    t
  } = useLanguage();
  return <section className="py-12 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-253">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-6xl mx-auto bg-gradient-to-r from-[#2563EB] to-[#8A31F1] rounded-[2.5rem] overflow-hidden shadow-2xl relative flex flex-col md:flex-row items-stretch" data-id="element-254">
        {/* Decorative elements */}
        <div className="absolute top-10 right-10 text-white/20 pointer-events-none" data-id="element-255">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-256">
            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-257" />
          </svg>
        </div>

        {/* Left Content */}
        <div className="p-12 md:p-16 md:w-3/5 z-10 flex flex-col justify-center" data-id="element-258">
          <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight mb-4" data-id="element-259">
            {t.ctaBanner.title}
          </h2>
          <p className="text-white/80 text-lg md:text-xl mb-10" data-id="element-260">
            {t.ctaBanner.subtitle}
          </p>
          <div data-id="element-261">
            <button onClick={() => window.location.href = 'https://tokoteta.id/auth/register'} className="inline-flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-300 text-black font-bold px-8 py-4 rounded-full transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5" data-id="element-262">
              {t.ctaBanner.button}
              <ArrowRight size={20} data-id="element-263" />
            </button>
          </div>
        </div>

        {/* Right Content - Phone Illustration */}
        <div className="md:w-2/5 relative flex items-end justify-center md:justify-end overflow-hidden" data-id="element-264">
          <img src="https://cdn.magicpatterns.com/uploads/hUoaCkZALxSLQ2J6nar5B3/Group_13940.png" alt="Tokoteta App" className="w-full max-w-md h-auto object-contain object-bottom block" data-id="element-265" />
        </div>
      </motion.div>
    </section>;
}